// @team BFA Acquisition
import Terms from '../../features/Gifting/pages/Terms';
import { withApolloContext } from '../../utils/apollo';

const Cmp = withApolloContext({ ssr: true })(Terms);

Cmp.displayName = 'Terms';

export default Cmp;
